<template>

<div v-if="site && engine && revision" class="page-print">
	<div class="page-header">

		<div>
			<h3 class="m-0"><b>ITALMOTORI</b> s.r.l. </h3>
			
		</div>
		<div>
		<p><b>REPORT INTERVENTO TECNICO</b></p>
		</div>
		<p class="small">
			Sede legale: Corso Milano, 83 - 35139 Padova (PD)<br>
			Ufficio e deposito: via Matteotti, 4/1 <br>
			35020 Z.I. Arzergrande (PD)<br>
			Tel. 049 9724315- Fax 049 9724665
		</p>
	</div>
	<div class="page-footer"></div>
	<table>
		<thead>
		  <tr>
			<td>          
			  <div class="page-header-space"></div>
			</td>
		  </tr>
		</thead>

		<tbody>
		  <tr>
			<td>
			<!-- page -->
				<div class="page">
					<print-revision-header 
						:revision="revision"
						:site="site"
						:engine="engine"
						/>
					<hr>

					<print-worked-details 
						:calculate="calculateTotalOfWorkedDeatails"
						:revision="revision" /> 

					<hr  v-if="revision.anomalyDescription || revision.activityDescription">

					<print-activity-details 
						:revision="revision" />
					<hr>

					
					<div class="data-table products-used">
						<p style="margin: 1.25rem 0;"><b>PRODOTTI UTILIZZATI</b></p>
						<div class="prod-list">
							<div class="prod-row">
								<span>codice</span>
								<span>quantità</span>
								<span>descrizione</span>
							</div>
							<div class="prod-row"
								v-for="(product,$index) in revision.productsUsed"
								:key="$index">
									<p>{{ product.code }}</p>
									<p>{{ product.quantity }}</p>		
									<p>{{ product.description }}</p>
							</div>
						</div>
						<br>
					</div>
					<hr>

					<div class="data-table direction-row-reverse client">
						<div class="client-note w-100">
							<span 
								v-if="revision.clientsNote"
								class="mt-4 mb-2">
								note del cliente
							</span>
							<p>{{revision.clientsNote}}</p>
						</div>
					</div>
					<div class="data-table direction-row-reverse client">
						<div class="signature">
							<span>firma Operatore</span>
							<img :src="revision.author.signature">
						</div>
						<div class="signature">
							<span >firma Cliente</span>
							<img :src="revision.signature">
						</div>

						<div class="signature">
							<span>data</span>
							<p>{{ revision.revisionDate  | moment('DD/MM/YYYY')}}</p>
						</div>
					</div>
					<hr>
				</div>

			</td>
		  </tr>
		</tbody>

		<tfoot>
		  <tr>
			<td>
			  <div class="page-footer-space"></div>
			</td>
		  </tr>
		</tfoot>

	</table>


<!-- 

	<div style="margin: auto; padding: 3rem; max-width: 1250px;"> 

		<h6>site</h6>

		<pre>{{site}}</pre>

		<h6>engine</h6>

		<pre>{{engine}}</pre> 

		<h6>revision</h6>

		<pre>{{revision}}</pre>

		<h6>Dettaglio ore</h6>

		<pre>{{revision.workedDetails}}</pre>

		<h6>Prodotti</h6>

		<pre>{{revision.productsUsed}}</pre>

	</div>  

-->

	
	</div>
  <loading v-else />
</template>
<script>
	
import { mapState, mapActions } from 'vuex'
import PrintRevisionHeader from './RevisionHeader.vue'
import PrintWorkedDetails from './WorkedDetails.vue'
import PrintActivityDetails from './ActivityDetails.vue'

export default{
	components:{
		PrintActivityDetails,
		PrintRevisionHeader,
		PrintWorkedDetails
	},
  computed: {
	...mapState({
	  revisions: state => state.revisions.revisions,
	  site: state => state.sites.site,
	  revision: state => state.revisions.revision,
	  engine: state => state.engines.engine,
	  loading: state => state.engines.loading,
	  user: state => state.account.user,
	})
  },
  async mounted() {
	const {engineId, id} = this.$route.params;
	await this.get({engineId, id})
	this.getEngine({id: engineId})
  },
  watch: {
	engine: function(newValue) {
	  if (newValue !== null){
		this.getSite(newValue.site)
	  }
	},
	site: function(newValue){
		if (newValue && newValue.id){
			setTimeout(() => {
				window.print()
			},300);
		}
	},
	async $route(from,to) {
	  const {engineId, id} = this.$route.params;
	  await this.get({engineId, id})
	  this.getEngine({id: engineId})
	}
  },
  data() {
  	return {
  		pistonsArray: [...Array(16)].map(( u,i ) => i + 1 )
  	}
  },
  methods: {
	...mapActions('engines', {
	  getEngine: 'get'
	}),
	...mapActions('sites', {
	  getSite: 'get'
	}),
	...mapActions('revisions', {
	  get: 'get',
	  update: 'update'
	}),
	printText(val){
		return val ?  val.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''
	},
	calculateTotalOfWorkedDeatails(key){
		let sum = 0;
		this.revision.workedDetails.days.forEach(day => {
			sum = day[key] ? sum + parseFloat(day[key]) : sum;
		})
		const total = parseFloat(this.revision.workedDetails.detailsSingleAmount[key]) * sum;
		return isNaN(total) ? 0 : total;
	},
	
  },
}	
</script>